<template>
<div class="set-wrap">
    <div class="set">
        <div class="nav clearfix">
            <router-link to='/mine'>
                <img class="navBack pull-left" src="../../../static/images/shootShop/back.png" alt="">
            </router-link>
            <h2 class="navTitle pull-left">设置</h2>
        </div>
        <div class="set-main">
            <ul class="clearfix">
                <li class="clearfix"><span class="span1">当前版本</span><span>3.8.0</span></li>
                <li class="clearfix"><span class="span1">清除缓存</span></li>
            </ul>

            <div class="btn" v-if="showBtn" @click="btnFun()">退出登录</div>

        </div>
    </div>
</div>
</template>
<script>
import $ from '../../../static/js/jquery.min.js';
import axios from 'axios';
import qs from 'qs';
export default {
    name: 'set',
    data () {
        return {
            showBtn: false
        }
    },
    computed:{

    },
    updated(){

    },
    methods:{
        btnFun(){
            layer.open({
                content: '退出成功',
                skin: 'msg',
                time: 2
            });
            this.showBtn = false;
            window.localStorage.clear();
            // 传值给navTab组件
            // Bus.$emit('msg', '传值');

            function clearCookie() {
                var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
                if (keys) {
                    for (var i = keys.length; i--;) {
                        //正式环境
                        document.cookie = keys[i] + '=0;path=/;domain=.youpuchina.com;expires=' + new Date(0).toUTCString();//清除一级域名下的或指定的，例如 .kevis.com
                        //测试环境
                        // document.cookie = keys[i] + '=0;path=/;domain=.yingshangchina.com;expires=' + new Date(0).toUTCString();//清除一级域名下的或指定的，例如 .kevis.com
                    }
                }
            }
            clearCookie();
        }

    },
    mounted() {
        if(localStorage.token){
            this.showBtn = true;
        }

    }
}
</script>

<style scoped lang="scss">
/*浮动*/
.pull-right{
    float: right;
}
.pull-left{

    float: left;
}
.clearfix:after {
    content: " ";
    display: block;
    clear: both;
    height: 0;
}
.clearfix {
    zoom: 1;
}

input::-webkit-input-placeholder{
    color:#fff;
}
input::-moz-placeholder{   /* Mozilla Firefox 19+ */
    color:#fff;
}
input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
    color:#fff;
}
input:-ms-input-placeholder{  /* Internet Explorer 10-11 */
    color:#fff;
}
/*内容部分*/
.set-wrap{
    width: 7.5rem;
    height: 100vh;
    margin: 0 auto;
    background: #fff;
}
.set{
    width: 7.5rem;
    margin: 0 auto;
    background: #fff;
    padding-top: .88rem;
}
.nav{
    width: 6.9rem;
    height: .88rem;
    background: #fff;
    margin: 0 auto;
    padding:  0 0.3rem;
    position: fixed;
    top: 0;
    z-index: 99;
}
.nav a{
  -webkit-tap-highlight-color: rgba(0,0,0,0);
}
.navBack{
    width: 0.2rem;
    height: 0.36rem;
    margin-top: 0.26rem;
}
.navTitle{
    height: .88rem;
    width: 6.4rem;
    line-height: .88rem;
    font-size: 0.36rem;
    color: #3c3c3c;
    text-align: center;
}

.set-main{
    width: 6.9rem;
    padding: 0 .3rem;
    ul{
        li{
            padding: .4rem 0;
            border-bottom: .02rem solid #e7e7e7;
            span{
                float: right;
                color: #9f9fa8;
                font-size: .24rem;
                line-height: .3rem;
            }
            .span1{
                float: left;
                color: #333;
                font-size: .3rem;
            }
        }
    }
    .btn{
        width: 6.9rem;
        height: .88rem;
        background: #2f7af7;
        line-height: .88rem;
        text-align: center;
        color: #fff;
        font-size: .32rem;
        margin-top: .3rem;
        border-radius: 10px;
        -webkit-tap-highlight-color: rgba(0,0,0,0);
    }
}

</style>



// WEBPACK FOOTER //
// src/components/mine/set.vue